var D={50:"#FDF5F6",100:"#FBEBEC",200:"#F7D8D9",300:"#EB9DA2",400:"#DD585F",500:"#D73A43",600:"#B73139",700:"#97292F",800:"#6B1D21"};export{D as default};
